// extracted by mini-css-extract-plugin
module.exports = {"body-content":"layout_body-content__3-z5b"};